// frontend/src/lib/demo-identity.ts
//
// Who the product is talking to. Set once here so the rail, the header, the
// briefing greeting and the AI Manager greeting can never disagree.
//
// The demo is driven from one shared login, so the session name is not the
// person in the room. `NEXT_PUBLIC_DEMO_FIRST_NAME` changes the greeting
// everywhere with no other edit; `NEXT_PUBLIC_DEMO_FULL_NAME` changes the name
// written on every decision. The app greets Ciby and records "Ciby Yohannan"
// (bible section 3.2).

const FIRST_NAME_OVERRIDE = process.env.NEXT_PUBLIC_DEMO_FIRST_NAME?.trim()

/** The first name every screen greets. */
export const DEMO_FIRST_NAME: string = FIRST_NAME_OVERRIDE || 'Ciby'

/**
 * The full name written on decisions, audit rows and letters. When only the
 * first name is overridden, the override is used on its own.
 */
export const DEMO_FULL_NAME: string =
  process.env.NEXT_PUBLIC_DEMO_FULL_NAME?.trim() || FIRST_NAME_OVERRIDE || 'Ciby Yohannan'

/** The role line under the name in the rail user block and the user menu. */
export const DEMO_ROLE_LINE = 'Procurement and Supply Chain'

/** "Ciby Yohannan" -> "CY"; one word gives one letter. */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  const first = parts[0].charAt(0)
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : ''
  return `${first}${last}`.toUpperCase()
}

/** Initials for the navy disc: "CY". */
export const DEMO_INITIALS: string = initialsOf(DEMO_FULL_NAME)

/** Kept for callers that show one letter. */
export const DEMO_INITIAL: string = DEMO_INITIALS.charAt(0)
